export const environment = {
  production: true,
  rutaBase:"https://api.starkengine.com",
 // rutaBase:"https://api.crowdin.la", 
  secret_key: "cd2nRttcAGmIiw4WeK5MUUnbowoabW",
  ROLE_ADMIN_ID: 44,
  ROLE_RIESGO_ID: 44,
  LABEL_PROVEEDOR:"Emisor",
  LABEL_PROVEEDORES:"Emisores",
  LABEL_ADQUIRENTE:"Receptor",
  LABEL_ADQUIRENTES:"Receptores",
  LABEL_PROSPECTO:"Prospecto",
  LABEL_PROSPECTOS:"Prospectos",
  LABEL_SIMULADOR:"Simulador",
  LABEL_PROFORMA:"Proforma",
  LABEL_PROFORMAS:"Proformas",
  LABEL_REF_BANCARIAS:"Referencias Bancarias",
  ID_MONEDA_SOLES:640,
  ID_MONEDA_DOLARES:642,
  ID_SERVICIO_FACTORING:765,
  ID_SERVICIO_CONFIRMING:766, 
  ID_GUIA_SOLES:640, // no aplica para factor j
  ID_GUIA_DOLARES:642,
  ID_MONEDA:641,
  ID_BANCO:643,
  ID_PAGO:660,
  ID_TIPO_COMPROBANTEIF:664,
  ID_TIPO_DOC_IDENTIFICACION:669,
  ID_IGV_EXONERADO:673,
  ID_COMPROBANTE_EMITIDO:676,
  ID_COMPROBANTE_CONTA:680,
  ID_ROL_CONTACTO:683,
  ID_CONDICION:689,
  ID_TIPO_CONTACTO:694,
  ID_TIPO_CONFORMIDA:698,
  ID_TIPO_COMPROBANTE:703,
  ID_TIPO_EMISION:706,
  ID_RETENCION_FONDO:709,
  ID_RETENCION:712,
  ID_TIPO_XLS:715,
  ID_TIPO_PLANTILLA:723,
  ID_TIPO_CUENTA:728,
  ID_BANCO_IF:731,
  ID_PARTICIPANTE:734,
  ID_RUT:737,
  ID_TIPO_SOLICITUD:740,
  ID_TIPO_OPERACION:743,
  ID_TIPO_PAGOCPE:746,
  ID_TIPO_OPERACION_NC:749,
  ID_TIPO_OPERACION_ND:760,
  ID_TIPO_SERVICIO:764,
  ID_TIPO_PAGARE:768,
  ID_TIPO_PROCESO:771,
  ID_TIPO_ADJUNTO:775,
  ID_FACTOR_REPRESENTANTE:780,
  ID_FACTOR_DATOS:786,
  ID_FACTOR_BANCO:791,
  ID_TIPO_FACTURACION:827,
  ID_TIPO_DNI:670,
  ID_CARNET:671,
  ID_RUC:672,
  ID_IGV_No_Exonerado:675,
  ID_FACTORING:765,
  ID_CONFIRMING:766,
  ID_DESCUENTO:785,
  ID_DEPOSITO_BANCARIO:661,
  ID_PLANILLA_DE_COLOCACION:662,
  ID_PLANILLA_DE_REMANENTE:663,
  TIPO_PROCESO:{
    CONTRATO_MARCO : 773
  },
  TIPO_PAGARE:{
    COMPLETO:769,
    INCOMPLETO:770
  } 
};
